import { render, staticRenderFns } from "./tbMonthly.vue?vue&type=template&id=637a399b&scoped=true&"
import script from "./tbMonthly.vue?vue&type=script&lang=js&"
export * from "./tbMonthly.vue?vue&type=script&lang=js&"
import style0 from "./tbMonthly.vue?vue&type=style&index=0&id=637a399b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637a399b",
  null
  
)

export default component.exports